import { render } from "./UserChat.vue?vue&type=template&id=0b0f2e77&scoped=true"
import script from "./UserChat.vue?vue&type=script&lang=js"
export * from "./UserChat.vue?vue&type=script&lang=js"

import "./UserChat.vue?vue&type=style&index=0&id=0b0f2e77&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0f2e77"]])

export default __exports__